import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { useEffect, useMemo, useState } from "react";
import IntellipayStoreOnlyMode from "./IntellipayStoreOnlyMode";
import { useAxiosInstance } from "../services/Interceptor";
import { GetAdminPrice } from "../services/EventsService";

const FreeTrialModal = ({ open, onClose, user, onStoreSuccessChain }) => {
  const startDateText = useMemo(() => {
    const d = new Date();
    d.setDate(d.getDate() + 7);
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  }, []);

  const apiInstance = useAxiosInstance();
  const [monthlyPrice, setMonthlyPrice] = useState(null);
  const [priceLoading, setPriceLoading] = useState(false);

  useEffect(() => {
    const loadPrice = async () => {
      if (!open) return;

      try {
        setPriceLoading(true);
        const adminPrices = await GetAdminPrice(apiInstance);
        const athletePricing = adminPrices?.data?.find(
          (option) => option.role.toLowerCase() === "athlete",
        );
        setMonthlyPrice(athletePricing?.pricingOptions?.monthlyPrice ?? 0);
      } catch (e) {
        setMonthlyPrice(0);
      } finally {
        setPriceLoading(false);
      }
    };

    loadPrice();
  }, [open, apiInstance]);

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-gray-500/75" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="w-full max-w-xl space-y-4 border bg-white rounded-lg p-6">
          <DialogTitle className="text-lg font-bold">
            Start your 7-day free trial
          </DialogTitle>

          <p className="text-sm text-gray-700">
            You’re on your way to unlocking all of the premium features of a
            Trackit Verified Subscription. After your 7 day free trial your
            credit card will be charged{" "}
            {priceLoading ? "..." : monthlyPrice ? `$${monthlyPrice}` : ""}{" "}
            monthly beginning on{" "}
            <span className="font-semibold">{startDateText}</span>.
          </p>

          <div className="flex items-center justify-end gap-3 pt-2">
            <button
              className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50"
              onClick={onClose}
              type="button"
            >
              Cancel
            </button>

            <button
              className="px-4 py-2 rounded-md bg-red-500 text-white hover:bg-red-700 ipayfield"
              data-ipayname="submit"
              type="button"
            >
              Enter my credit card information
            </button>
          </div>

          <div className="space-y-3">
            <IntellipayStoreOnlyMode
              userEmail={user.email}
              userId={user.id}
              paymentAmount={0}
              eventId={0}
              onRegistrationSuccess={() => {
                onClose();
              }}
              onStoreSuccess={onStoreSuccessChain}
              onNonApproval={(res) => {
                onClose();
              }}
            />
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default FreeTrialModal;
